import React from 'react';
import SectionHeader from './SectionHeader';

const StatsSection = ({
    sectionClassName,
    header,
    gridClassName,
    cardClassName,
    valueClassName,
    labelClassName,
    items
}) => (
    <section className={sectionClassName}>
        <div className="container">
            <SectionHeader
                wrapperClassName={header.wrapperClassName}
                subtitleClassName={header.subtitleClassName}
                titleClassName={header.titleClassName}
                subtitle={header.subtitle}
                title={header.title}
            />
            <div className={gridClassName}>
                {items.map((item) => (
                    <div key={item.label} className={cardClassName}>
                        <div className={valueClassName}>{item.value}</div>
                        <div className={labelClassName}>{item.label}</div>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default StatsSection;

